import { create } from "zustand";

interface AppStatusState {
  maintenanceMessage: string | null;
  forbiddenMessage: string | null;
  setMaintenance: (message: string | null) => void;
  clearMaintenance: () => void;
  showForbidden: (message: string) => void;
  dismissForbidden: () => void;
}

/**
 * App-wide UI status flags that affect global rendering. useApiError flips
 * these when receiving MAINTENANCE_MODE or FORBIDDEN envelopes; the
 * MaintenanceBanner and ForbiddenModal components subscribe.
 */
export const useAppStatusStore = create<AppStatusState>((set) => ({
  maintenanceMessage: null,
  forbiddenMessage: null,
  setMaintenance: (message) => set({ maintenanceMessage: message }),
  clearMaintenance: () => set({ maintenanceMessage: null }),
  showForbidden: (message) => set({ forbiddenMessage: message }),
  dismissForbidden: () => set({ forbiddenMessage: null }),
}));
